// extracted by mini-css-extract-plugin
export default {"root":"nhjp1N","container":"jqkBjD","hosts":"GhrxUO","guests":"GdHKyN","divider":"HsaQRi"};